<template>
  <div class="between">
    <div
      class="center"
      style="cursor: pointer; position: relative"
      @click="$router.push({ path: '/backlog' })"
      v-if="!$route.path.includes('/backlog')"
    >
      <el-image
        style="width: 28px; height: 28px; margin-right: 10px"
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/待办@2x-140401408.png"
      ></el-image>
      <span class="badge" v-if="todoNum">
        {{ todoNum > 99 ? 99 : todoNum }}</span
      >
      <span>我的待办</span>
    </div>

    <el-image
      style="width: 18px; height: 18px; cursor: pointer"
      src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/帮助@2x (2)-140946494.png"
      @click="toSite"
    ></el-image>

    <el-dropdown>
      <div>
        <el-image
          :src="user.avatar"
          class="photo rounded"
          v-if="user.avatar"
        ></el-image>
        <div v-else class="photo center rounded">
          {{ user.name?.substring(user.name.length - 2) }}
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="user.isAdmin"
          @click.native="$router.push({ path: '/cmsAdmin' })"
          >管理中心</el-dropdown-item
        >
        <el-dropdown-item
          @click.native="$store.dispatch('user/logOut')"
          v-if="!isDD"
          >退出登录</el-dropdown-item
        >
        <el-dropdown-item @click.native="browserOpen" v-if="isDD"
          >在浏览器中打开</el-dropdown-item
        >
        <el-dropdown-item v-if="user.isAdmin">{{
          $version()
        }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";

export default {
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters.userInfo;
    },
    isDD() {
      return dd.env.platform !== "notInDingTalk" ? true : false;
    },
    todoNum() {
      return this.$store.state.user.todoNum;
    },
  },
  methods: {
    // 获取待办总数
    // 在钉钉中打开会有在浏览器中打开
    browserOpen() {
      dd.biz.util.openLink({
        url: `http://cloud.yibeirui.com/#/home?code=${this.$route.query.code}&ddToken=${this.$store.getters.token}`,
      });
    },
    toSite() {
      if (!this.user.isAdmin) return;
      this.$router.push({ path: "/site" });
    },
  },
};
</script>

<style scoped>
span {
  line-height: 20px;
  font-size: 16px;
  margin-left: 6px;
  color: #525967;
  margin-right: 24px;
}

.photo {
  width: 34px;
  height: 34px;
  background: #107fff;
  color: #fff;
  border: 1px solid #ffffff;
  margin-left: 24px;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
}

.badge {
  position: absolute;
  top: -7px;
  left: 12px;
  width: fit-content;
  height: 16px;
  background-color: #ff3d45;
  border-radius: 9px;
  border: 1px solid #ffffff;
  font-size: 12px;
  color: #ffffff;
  padding: 0 5px;
  line-height: 16px;
}
</style>